// @flow

// Libs
import React from 'react'

// Messages
import { FormattedMessage } from 'react-intl'
import messages from 'fc-datatable-assets/src/messages'

// Constants
import {
  SMALL_SIZE,
  LARGE_SIZE,
  SORT_AS_NUMBER,
  SORT_AS_GROUP,
  SORT_AS_MIX,
  SORT_AS_BOOLEAN,
} from 'fc-component-datatable'
import {
  POINT,
  FEATURECOLLECTION,
} from 'fc-utils/geoJson'
import {
  ATTR_ASSET_ID,
  ATTR_LABEL,
  ATTR_CATEGORY,
  ATTR_SHAPE,
  ATTR_GROUP_BY_BOUNDARY_TYPE,
  ATTR_AREA,
  ATTR_MAP_VIEW,
  ATTR_HAS_ACTIVE_MAP_VIEW,
} from 'fc-datatable-assets/src/constants'

// Translate util
const translate = (column: Object): React.Element<any> => <FormattedMessage {...messages[column.attr]} />

// Columns config
export default [
  {
    attr: ATTR_ASSET_ID,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_NUMBER,
  },
  {
    attr: ATTR_LABEL,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_CATEGORY,
    size: SMALL_SIZE,
    render: translate,
  },
  {
    attr: ATTR_SHAPE,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_GROUP,
    groupBy: ATTR_GROUP_BY_BOUNDARY_TYPE,
    groupOrder: ['', POINT, FEATURECOLLECTION],
  },
  {
    attr: ATTR_AREA,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_MIX,
  },
  {
    attr: ATTR_MAP_VIEW,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_ACTIVE_MAP_VIEW,
  },
]
